// import Vue from 'vue'
// import Router from 'vue-router'
// import Mobile_PAD from '@/components/Mobile_PAD'
// import ErrorPage from '@/components/ErrorPage'
// Vue.use(Router)

// export default new Router({
//   mode: 'history',
//   routes: [{
//       path: '/error',
//       name: 'error',
//       component: ErrorPage
//     },
//     {
//       path: '/index.html',
//       name: 'Mobile_PAD',
//       component: Mobile_PAD
//     },
//     {
//       path: '/',
//       name: 'Mobile_PAD',
//       component: Mobile_PAD
//     },
//     {
//       path: '/*',
//       redirect: '/error'
//     },
//   ]
// })

let route = []
route.push({
  path: '*',
  component: require('./ErrorPage.vue').default
})
export default route



// WEBPACK FOOTER //
// ./src/pages/error/route.js